//import * as md5 from 'md5'

export default class Coverage {
  id: string

  pages
  story

  lang
  title: string
  slug: string
  date: string
  modified: string
  status: string
  type: string
  description: string
  link: string
  img: string

  menu_order

  cover

  coverage: string
  
  statut: string
  
  api
  social
  aware
    
  hash: string
  
  headers

  header_title_show
  back_color

  template
  product

  url
  photos

  lists

  tags

  rubrique


  constructor(id, json, lang) {

     //this.template = this.coverage2.data.wp.header[0] || {};
    //var data = json.data || {};
    if(!json) return;
    
    var wp = json.wp || {};
    var headers = wp.header || null;
    var template = wp.template || {};

    this.header_title_show = template.header_title_show || false;
    this.back_color = template.back_color || false;

    let lists = json.lists || {};
    this.lists = {};
    this.lists.material = lists.material || [];
    this.lists.color = lists.color || [];
    this.lists.propriete = lists.propriete || [];

    this.pages = json.pages || null;
    this.story = json.story || null;


    //this.pages_liste = this.story.pages;

    if(headers) this.headers = headers || null;
    //if(!this.coverage) this.id = 1273;
    //console.log(this.headers)
    //this.test = this.coverageService.coverage(1338);

    /*if(lang==='fr') {
      this.title = json.title_fr || ''
      //this.description = json.description_fr || ''
      //this.link_text = json.link_fr || null
      //this.rubrique = json.rubrique_fr || null
    }
    else if(lang==='ang') {
      this.title = json.title_ang || ''
      //this.description = json.description_ang || ''
      //this.link_text = json.link_ang || null
      //this.rubrique = json.rubrique_ang || null
    }*/


    this.id = id || ''
    let language = wp.lang || {}
    if(this.story) language = this.story.lang || {}

    let language2 = language[lang] || {}
    this.title = language2.name;

    if(!this.title) {
      var lang2
      if(lang==='fr') lang2 = 'ang'; else lang2 = 'fr';

      let language2 = language[lang2] || {}
      this.title = language2.name;
    }

    this.slug = wp.slug || ''   
    this.menu_order = wp.menu_order || '200'   

    this.rubrique = wp.rubrique || {}

    this.date = wp.date || ''
    this.modified = wp.modified || ''
    this.status = wp.status || ''
    this.type = wp.type || ''
    this.description = wp.description || ''
    this.link = wp.link || ''

    this.tags = wp.tags || {}
//if(this.id===1273) this.header = this.coverageService.coverage(1273);

    this.template = wp.template;

    
    this.coverage = wp.coverage || ''
    this.product = wp.product || null //primary

    if(this.product) {
      let product_lang1 = this.product.lang || {}
      let product_lang = product_lang1[lang] || {}

      this.product.name = product_lang.name || null;
      this.product.description = product_lang.description || null;
      this.product.description2 = product_lang.description2 || null;
      this.product.construction = product_lang.construction || null;

      //var curencySign = '€'
      //var curencySign2 = '$'
      //var curency = 'euro'
      //var curency2 = 'dollar'
      //if(lang==='fr') {curency = 'euro';curencySign = '€';curency2 = 'dollar';curencySign2 = '$';} else {curency = 'dollar';curencySign = '$';curency2 = 'euro';curencySign2 = '€';}


      var product_price = this.product.price || {};
      //var lang_curency = product_price[curency] || null;

      var curency_euro = product_price['euro'] || {};
      var curency_dollar = product_price['dollar'] || {};

      //if(!lang_curency) {lang_curency = product_price[curency2] || null; curencySign = curencySign2;}

      this.product.prix = {}//lang_curency.value + curencySign || null;
    
      this.product.prix.euro = curency_euro.value || null;
      this.product.prix.dollar = curency_dollar.value || null;
          //console.log(product_price, curency, lang_curency)

    }
    
    //let statut = json.statut || null
    
   
    
    this.api = json.api || {}
    this.social = json.social || {}
    
    
    
    //let api = this.api || {}
    //let twitter = api.twitter || null
    
    let aware = json.aware || null;
    if(aware) {
      this.social.concat(aware);
      this.aware = this.sumAware(aware);
    }
    else this.aware = {};

    // console.log(this.social,'hj ');
    

    
    this.img = wp.img || ''
    this.cover = wp.cover || null;

    this.url = wp.url || null;
    this.photos = wp.photos || {};
    
    /*if(!this.api.twitter){} else {
      //if(this.img === 'facebook') this.img = ''
      //else if(this.img === 'twitter') {
        this.img = json.api.twitter.img || ''

        this.cover = json.api.twitter.cover || ''
      //}
    }*/
    
    //this.hash = md5(this.name)
  }

  getstatut(size: number = 100): string {
    
    //if(this.img==='facebook') 
    return 'this.img_twitter'
    //return `http://www.gravatar.com/avatar/${this.hash}?d=retro&s=${size}`
  }

  sumAware (provider) {

    //this.aware 
    //console.log(provider, 'provider')
    //array.for(function (value) {
    //    this.sum += value;
    //}, this);
    var sum = 0;

    for(let api in provider) {
      sum += provider[api].count || 0;
    }
  
    return sum;

  }

}



// WEBPACK FOOTER //
// ./src/models/coverage.model.ts